import { render } from "./Univ-Details.vue?vue&type=template&id=a825fdbe&scoped=true"
import script from "./Univ-Details.vue?vue&type=script&lang=js"
export * from "./Univ-Details.vue?vue&type=script&lang=js"

import "./Univ-Details.vue?vue&type=style&index=0&id=a825fdbe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a825fdbe"

export default script